import { useEffect } from "react";

export function useDebounce(callback: () => void, ms = 0, dependencies: ReadonlyArray<unknown> | null = []) {
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const token = setTimeout(callback, ms);

    return () => {
      clearTimeout(token);
    };
    // @ts-expect-error
  }, dependencies);
}
